import Page from 'components/layout/Page';
import ApplicationsCompanies from './ApplicationsCompanies';
import ApplicationsCta from './ApplicationsCta';
import ApplicationsFaqs from './ApplicationsFaqs';
import ApplicationsFeatures from './ApplicationsFeatures';
import ApplicationsHero from './ApplicationsHero';

const ApplicationsComponent: React.FC = () => {
  return (
    <Page hasScrollTop>
      <ApplicationsHero />
      <ApplicationsFeatures />
      <ApplicationsCta />
      <ApplicationsFaqs />
      <ApplicationsCompanies />
    </Page>
  );
};

export default ApplicationsComponent;
